import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useQuery } from "@tanstack/react-query";
import { MaintenanceObjectivePartsData } from "../types/MaintenanceObjectiveParts.type";

const useMaintenanceObjectivePart = (id?: string) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: MaintenanceObjectivePartsData } }, unknown, MaintenanceObjectivePartsData>({
    enabled: !!id,
    queryKey: ['maintenanceObjectivePart', id],
    queryFn: () => privateAxios.get(`/maintenance/objective_parts/${id}`),
    select: (data) => data?.data?.data,
  });
}

export default useMaintenanceObjectivePart;
